/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Flag_State_DetailInputs */



/**
* | output |
* | --- |
* | "Inspections carried out on behalf of flag state administrations to verify that a vessel meets the flag's statutory and safety requirements. The findings supp..." |
*
* @param {Service_Flag_State_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_flag_state_detail = /** @type {((inputs?: Service_Flag_State_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Flag_State_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("代表船旗国主管机关开展检查，核实船舶是否符合该船旗国的法定和安全要求。检查结果为船旗国监管其登记船舶提供支持。")
	return /** @type {LocalizedString} */ ("Inspections carried out on behalf of flag state administrations to verify that a vessel meets the flag's statutory and safety requirements. The findings support the flag state's oversight of the vessels on its register.")
});